var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_14070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.57672C8.13 2.57672 5 5.2927 5 8.6508C5 13.2064 12 19.9312 12 19.9312C12 19.9312 19 13.2064 19 8.6508C19 5.2927 15.87 2.57672 12 2.57672ZM12 10.8201C10.62 10.8201 9.5 9.84826 9.5 8.6508C9.5 7.45334 10.62 6.48148 12 6.48148C13.38 6.48148 14.5 7.45334 14.5 8.6508C14.5 9.84826 13.38 10.8201 12 10.8201Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_14070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20.8254,
    fill: "white",
    transform: "translate(0 0.841248)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.010f9e26.svg";
export { ForwardRef as ReactComponent };